export const scotiaTS = [
  {
    'datetime': 1559347200,
    'visitors': 236874
  },
  {
    'datetime': 1559433600,
    'visitors': 197616
  },
  {
    'datetime': 1559520000,
    'visitors': 60591
  },
  {
    'datetime': 1559606400,
    'visitors': 119372
  },
  {
    'datetime': 1559692800,
    'visitors': 106846
  },
  {
    'datetime': 1559779200,
    'visitors': 146000
  },
  {
    'datetime': 1559865600,
    'visitors': 222593
  },
  {
    'datetime': 1559952000,
    'visitors': 258131
  }
  // ,
  // {
  //   'datetime': 1560038400,
  //   'visitors': 258131
  // },
  // {
  //   'datetime': 1560124800,
  //   'visitors': 60591
  // },
  // {
  //   'datetime': 1560211200,
  //   'visitors': 119372
  // },
  // {
  //   'datetime': 1560297600,
  //   'visitors': 106846
  // },
  // {
  //   'datetime': 1560384000,
  //   'visitors': 146000
  // },
  // {
  //   'datetime': 1560470400,
  //   'visitors': 222593
  // },
  // {
  //   'datetime': 1560556800,
  //   'visitors': 217342
  // },
  // {
  //   'datetime': 1560643200,
  //   'visitors': 217342
  // },
  // {
  //   'datetime': 1560729600,
  //   'visitors': 60591
  // },
  // {
  //   'datetime': 1560816000,
  //   'visitors': 119372
  // },
  // {
  //   'datetime': 1560902400,
  //   'visitors': 106846
  // },
  // {
  //   'datetime': 1560988800,
  //   'visitors': 146000
  // },
  // {
  //   'datetime': 1561075200,
  //   'visitors': 222593
  // },
  // {
  //   'datetime': 1561161600,
  //   'visitors': 217342
  // },
  // {
  //   'datetime': 1561248000,
  //   'visitors': 133463
  // },
  // {
  //   'datetime': 1561334400,
  //   'visitors': 60591
  // },
  // {
  //   'datetime': 1561420800,
  //   'visitors': 119372
  // },
  // {
  //   'datetime': 1561507200,
  //   'visitors': 106846
  // },
  // {
  //   'datetime': 1561593600,
  //   'visitors': 146000
  // },
  // {
  //   'datetime': 1561680000,
  //   'visitors': 222593
  // },
  // {
  //   'datetime': 1561766400,
  //   'visitors': 133463
  // },
  // {
  //   'datetime': 1561852800,
  //   'visitors': 266926
  // }
]

export const zooTS = [
  {
    'datetime': 1559347200,
    'visitors': 150984
  },
  {
    'datetime': 1559433600,
    'visitors': 126142
  },
  {
    'datetime': 1559520000,
    'visitors': 68189
  },
  {
    'datetime': 1559606400,
    'visitors': 50038
  },
  {
    'datetime': 1559692800,
    'visitors': 46693
  },
  {
    'datetime': 1559779200,
    'visitors': 56783
  },
  {
    'datetime': 1559865600,
    'visitors': 123055
  }
  // ,
  // {
  //   'datetime': 1559952000,
  //   'visitors': 122753
  // },
  // {
  //   'datetime': 1560038400,
  //   'visitors': 122749
  // },
  // {
  //   'datetime': 1560124800,
  //   'visitors': 68189
  // },
  // {
  //   'datetime': 1560211200,
  //   'visitors': 50038
  // },
  // {
  //   'datetime': 1560297600,
  //   'visitors': 46693
  // },
  // {
  //   'datetime': 1560384000,
  //   'visitors': 56783
  // },
  // {
  //   'datetime': 1560470400,
  //   'visitors': 123421
  // },
  // {
  //   'datetime': 1560556800,
  //   'visitors': 122862
  // },
  // {
  //   'datetime': 1560643200,
  //   'visitors': 122785
  // },
  // {
  //   'datetime': 1560729600,
  //   'visitors': 68189
  // },
  // {
  //   'datetime': 1560816000,
  //   'visitors': 50038
  // },
  // {
  //   'datetime': 1560902400,
  //   'visitors': 46693
  // },
  // {
  //   'datetime': 1560988800,
  //   'visitors': 56783
  // },
  // {
  //   'datetime': 1561075200,
  //   'visitors': 122544
  // },
  // {
  //   'datetime': 1561161600,
  //   'visitors': 122156
  // },
  // {
  //   'datetime': 1561248000,
  //   'visitors': 122459
  // },
  // {
  //   'datetime': 1561334400,
  //   'visitors': 68189
  // },
  // {
  //   'datetime': 1561420800,
  //   'visitors': 50038
  // },
  // {
  //   'datetime': 1561507200,
  //   'visitors': 46693
  // },
  // {
  //   'datetime': 1561593600,
  //   'visitors': 56783
  // },
  // {
  //   'datetime': 1561680000,
  //   'visitors': 122843
  // },
  // {
  //   'datetime': 1561766400,
  //   'visitors': 122269
  // },
  // {
  //   'datetime': 1561852800,
  //   'visitors': 245251
  // }
]

export const congTS = [
  {
    'datetime': 1559347200,
    'visitors': 36600
  },
  {
    'datetime': 1559433600,
    'visitors': 36600
  },
  {
    'datetime': 1559520000,
    'visitors': 142848
  },
  {
    'datetime': 1559606400,
    'visitors': 142439
  },
  {
    'datetime': 1559692800,
    'visitors': 146082
  },
  {
    'datetime': 1559779200,
    'visitors': 147612
  },
  {
    'datetime': 1559865600,
    'visitors': 116224
  }
  // ,
  // {
  //   'datetime': 1559952000,
  //   'visitors': 36600
  // },
  // {
  //   'datetime': 1560038400,
  //   'visitors': 21528
  // },
  // {
  //   'datetime': 1560124800,
  //   'visitors': 142707
  // },
  // {
  //   'datetime': 1560211200,
  //   'visitors': 142392
  // },
  // {
  //   'datetime': 1560297600,
  //   'visitors': 146361
  // },
  // {
  //   'datetime': 1560384000,
  //   'visitors': 147404
  // },
  // {
  //   'datetime': 1560470400,
  //   'visitors': 115639
  // },
  // {
  //   'datetime': 1560556800,
  //   'visitors': 21528
  // },
  // {
  //   'datetime': 1560643200,
  //   'visitors': 28153
  // },
  // {
  //   'datetime': 1560729600,
  //   'visitors': 142718
  // },
  // {
  //   'datetime': 1560816000,
  //   'visitors': 143015
  // },
  // {
  //   'datetime': 1560902400,
  //   'visitors': 146226
  // },
  // {
  //   'datetime': 1560988800,
  //   'visitors': 146577
  // },
  // {
  //   'datetime': 1561075200,
  //   'visitors': 116278
  // },
  // {
  //   'datetime': 1561161600,
  //   'visitors': 36600
  // },
  // {
  //   'datetime': 1561248000,
  //   'visitors': 36600
  // },
  // {
  //   'datetime': 1561334400,
  //   'visitors': 142640
  // },
  // {
  //   'datetime': 1561420800,
  //   'visitors': 142927
  // },
  // {
  //   'datetime': 1561507200,
  //   'visitors': 145826
  // },
  // {
  //   'datetime': 1561593600,
  //   'visitors': 146996
  // },
  // {
  //   'datetime': 1561680000,
  //   'visitors': 116436
  // },
  // {
  //   'datetime': 1561766400,
  //   'visitors': 30443
  // },
  // {
  //   'datetime': 1561852800,
  //   'visitors': 43108
  // }
]

export const botaTS = [
  {
    'datetime': 1559347200,
    'visitors': 198482
  },
  {
    'datetime': 1559433600,
    'visitors': 165731
  },
  {
    'datetime': 1559520000,
    'visitors': 59622
  },
  {
    'datetime': 1559606400,
    'visitors': 35718
  },
  {
    'datetime': 1559692800,
    'visitors': 31202
  },
  {
    'datetime': 1559779200,
    'visitors': 74705
  },
  {
    'datetime': 1559865600,
    'visitors': 161383
  }
  // ,
  // {
  //   'datetime': 1559952000,
  //   'visitors': 161111
  // },
  // {
  //   'datetime': 1560038400,
  //   'visitors': 161495
  // },
  // {
  //   'datetime': 1560124800,
  //   'visitors': 89622
  // },
  // {
  //   'datetime': 1560211200,
  //   'visitors': 65718
  // },
  // {
  //   'datetime': 1560297600,
  //   'visitors': 61202
  // },
  // {
  //   'datetime': 1560384000,
  //   'visitors': 74705
  // },
  // {
  //   'datetime': 1560470400,
  //   'visitors': 161442
  // },
  // {
  //   'datetime': 1560556800,
  //   'visitors': 160503
  // },
  // {
  //   'datetime': 1560643200,
  //   'visitors': 161878
  // },
  // {
  //   'datetime': 1560729600,
  //   'visitors': 89622
  // },
  // {
  //   'datetime': 1560816000,
  //   'visitors': 65718
  // },
  // {
  //   'datetime': 1560902400,
  //   'visitors': 61202
  // },
  // {
  //   'datetime': 1560988800,
  //   'visitors': 74705
  // },
  // {
  //   'datetime': 1561075200,
  //   'visitors': 161713
  // },
  // {
  //   'datetime': 1561161600,
  //   'visitors': 161011
  // },
  // {
  //   'datetime': 1561248000,
  //   'visitors': 161316
  // },
  // {
  //   'datetime': 1561334400,
  //   'visitors': 89622
  // },
  // {
  //   'datetime': 1561420800,
  //   'visitors': 65718
  // },
  // {
  //   'datetime': 1561507200,
  //   'visitors': 61202
  // },
  // {
  //   'datetime': 1561593600,
  //   'visitors': 74705
  // },
  // {
  //   'datetime': 1561680000,
  //   'visitors': 161695
  // },
  // {
  //   'datetime': 1561766400,
  //   'visitors': 161537
  // },
  // {
  //   'datetime': 1561852800,
  //   'visitors': 322673
  // }
]
